import React from 'react';
import './Toast.css';

/**
 * Single toast surface. Consumers normally don't render this directly —
 * <ToastProvider /> mounts it. Exported so consumers can render a one-off
 * announcement (e.g. in Storybook) without the provider.
 */
const Toast = React.forwardRef(function Toast(
  { children, onDismiss, leaving = false, className = '', ...rest },
  ref,
) {
  const composed = `glacier-toast${leaving ? ' is-leaving' : ''}${
    className ? ` ${className}` : ''
  }`;
  return (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      className={composed}
      onClick={onDismiss}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onDismiss) {
          e.preventDefault();
          onDismiss();
        }
      }}
      tabIndex={0}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Toast;
